import _ from 'lodash';
import { useState } from 'react';
import { MODALS } from '../../constants/modals.constants';
import { TOAST_TYPES } from '../../constants/settings.constants';
import { useModal } from '../../hooks/useModal.hook';
import { procedureGoalToTitle } from '../../lib/dossier.utils';
import DeleteWarningModal from '../../modals/DeleteWarningModal';
import procedureService from '../../services/api/procedure.service';
import toastService from '../../services/toasts.service';
import DossierSectionWrapper from '../dossier-details/DossierSectionWrapper';
import DossierProcedureGoal from './goals/DossierProcedureGoal';

const DossierProcedureGoals = ({
  dossierId,
  goals,
  attachments,
  openedGoals,
  setOpenedGoals,
  openedIndicators,
  setOpenedIndicators,
  onUpdated,
  onDossierRefetch,
  onAttachmentsRefetch,
  write
}) => {
  const deleteModal = useModal(MODALS.PROCEDURE_GOAL_CONFIRM_DELETE);
  const [creatingGoal, setCreatingGoal] = useState(false);
  const [deletingGoalId, setDeletingGoalId] = useState('');

  const handleAdd = () => {
    setCreatingGoal(true);
    procedureService.addGoal(dossierId, {
      onSuccess: (resp) => {
        setCreatingGoal(false);
        onDossierRefetch();
        setOpenedGoals([resp.id]);
      },
      onError: (message) => {
        toastService.showToast(TOAST_TYPES.ERROR, message);
        setCreatingGoal(false);
      }
    });
  };

  const handleUpdated = (value, field, goalId) => {
    const newGoalsData = _.cloneDeep(goals);
    if (newGoalsData?.length < 1) {
      return;
    }

    const itemIndex = newGoalsData.findIndex((i) => i.id === goalId);
    if (itemIndex === -1) {
      return;
    }
    newGoalsData[itemIndex] = { ...newGoalsData[itemIndex], [field]: value };
    onUpdated(newGoalsData, 'goals');
  };

  const handleDeleteConfirm = (goalId) => {
    setDeletingGoalId(goalId);
    deleteModal.onOpen();
  };

  const handleDelete = (onError, onSuccess) => {
    procedureService.deleteGoal(dossierId, deletingGoalId, {
      onSuccess: (resp) => {
        onSuccess(resp);
        onDossierRefetch();
      },
      onError
    });
  };

  return (
    <>
      <DossierSectionWrapper
        className="u-margin-bottom-lg"
        title="Doelstellingen"
        addLabel="Doelstelling toevoegen"
        isAdding={creatingGoal}
        noItemsLabel="Er zijn momenteel nog geen langetermijndoelen toegevoegd."
        onAddItem={write ? handleAdd : undefined}
        openedItemIds={openedGoals}
        onItemHeaderClick={(open, id) => {
          const newValue = open ? [...(openedGoals ?? []), id] : openedGoals?.filter((oc) => oc !== id) ?? [];
          setOpenedGoals(newValue);
        }}
        items={goals?.map((goal) => ({
          id: goal.id,
          title: procedureGoalToTitle(goal),
          Component: (
            <DossierProcedureGoal
              {...goal}
              write={write}
              attachments={attachments}
              dossierId={dossierId}
              openedIndicators={openedIndicators}
              setOpenedIndicators={setOpenedIndicators}
              onDossierRefetch={onDossierRefetch}
              onAttachmentsRefetch={onAttachmentsRefetch}
              onDelete={() => handleDeleteConfirm(goal.id)}
              onUpdated={handleUpdated}
            />
          )
        }))}
      />
      <DeleteWarningModal
        {...deleteModal}
        warningText="Ben je zeker dat je deze doelstelling wilt verwijderen? Alle informatie die hieraan gekoppeld is zal verloren gaan."
        onConfirm={handleDelete}
      />
    </>
  );
};

export default DossierProcedureGoals;
